export const superUsersThunkNames = {
    fetchSuperUsers: 'fetchSuperUsers',
    createUser: 'createSuperUser',
    deleteUser: 'deleteUser',
};
